import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

const recipesAdapter = createEntityAdapter({
  selectId: (recipe) => recipe._id,
});

const initialState = {
  ui: {
    loading: false,
    stats: {
      pageCount: 1,
      pageLimit: 20,
      docs: 1,
    },
  },
  recipes: recipesAdapter.getInitialState(),
  recipe: {},
};

export const recipesReducerSlice = createSlice({
  name: 'recipes',
  initialState,
  reducers: {
    get_recipes: (state) => {
      state.ui.loading = true;
    },
    get_recipes_success: (state, { payload }) => {
      state.ui.loading = false;
      state.ui.stats = {
        pageCount: payload.stats.page,
        pageLimit: payload.stats.limit,
        docs: payload.stats.docs,
      };
      state.recipes = recipesAdapter.setAll(state.recipes, payload.recipes);
    },
    get_recipes_error: (state) => {
      state.ui.loading = false;
    },
  },
});

// Action creators are generated for each case reducer function

export const { get_recipes, get_recipes_error, get_recipes_success } =
  recipesReducerSlice.actions;

export default recipesReducerSlice.reducer;

//export selector
export const recipesSelector = recipesAdapter.getSelectors();
